var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1170EC4E-CD2F-4EF9-BDE3-1C0BE839B945") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte-Versicherteninfos-bearbeiten-Popup",
    transform: "translate(-672.000000, -588.000000)",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(340.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Searchbar-Copy-7",
    transform: "translate(32.000000, 509.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(301.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinecap: "square",
    x: 0,
    y: 2,
    width: 18,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8 L0,8",
    id: "Path",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,4 L5,0",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,4 L13,0",
    id: "Path",
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCalendar);
export default __webpack_public_path__ + "static/media/blackCalendar.6c1a871b3c11d31a830c010137c86a55.svg";
export { ForwardRef as ReactComponent };